import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from '../../../shared/services/common.service';
import { CreateBookingService } from '../../create-booking/create-booking.service';

@Component({
  selector: 'app-requester-details',
  templateUrl: './requester-details.component.html',
  styleUrls: ['./requester-details.component.scss', '../../../shared/styles/summary.scss']
})
export class RequesterDetailsComponent implements OnInit {

  @Input() requester: any;
  @Input() paymentType: any;
  @Input() booking: any;
  @Input() miscellConfig: any;
  @Input() configComplete: any;
  @Input() escortConfig: any;

  public config: any[];
  openRecipientModal = false;
  showWarningDialog = false;
  isRiderSelf = false;
  showList = false;
  isTyping = false;
  enableBtn = false;
  isEscortEnabled = false;
  empList: any;
  employeeDetails = {
    name: '',
    emplID: '',
    emailID: '',
    mobile: [],
    code: '',
    phoneNum: '',
    guid: ''
  };
  recipientName = 'No recipient Selected';
  srcPath = '';
  subheaderText = 'The selected recipient will receive all your booking communication.';
  successBtn = 'successBtn';
  isBackDated = false;
  preponeTripSheetInHours: any;
  constructor(private commonService: CommonService, private createBookingService: CreateBookingService,   private authService: AuthService) { }

  ngOnInit() {
    this.isEscortEnabled = this.booking[0].guardReq;

    if (this.miscellConfig?.enableRepresentative){
      this.commonService.fetchRecipient(this.requester.emplGuid).subscribe(res => {
        if (res.length) {
          this.recipientName = res[0].name;
          this.srcPath = 'assets/ic-edit.svg';
          this.employeeDetails.emailID = res[0].emailId;
          this.employeeDetails.name = res[0].name;
          this.employeeDetails.emplID = res[0].employeeId;
          this.employeeDetails.mobile = this.getPhoneAndCountryCode(res[0].phone);
          this.employeeDetails.code = this.employeeDetails.mobile[0];
          this.enableBtn = true;
        }
      }, (error) => this.setInitialValue()
      );
      this.createBookingService.riderGuid.subscribe(res => {
          this.srcPath = 'assets/addRecipient.svg';
      });
     }
    this.commonService.fetchConfig().subscribe((response: any) =>
      this.config = this.commonService.getConfigForElementKey(response, 'Requester Form').elementConfigList);
    this.createBookingService.createBackDatedBooking.subscribe(res => this.isBackDated = res);



    this.preponeTripSheetInHours = this.escortConfig[0].preponeTripSheetInHours;
    this.createBookingService.preponeTripSheetInHours.next(this.preponeTripSheetInHours);

  }

  getEmployee(searchQuery: any) {
    if (searchQuery == "") {
      this.isTyping = false;
      this.showList = false;
      this.setInitialValue();
    }
    else {
      this.isTyping = true;
      this.createBookingService.fetchEmployees(searchQuery).subscribe(res => {
        this.showList = true;
        this.empList = res;
      });
    }
  }

  selectedEmp(selected) {
    this.enableBtn = true;
    this.employeeDetails.emailID = selected.emailId;
    this.employeeDetails.name = selected.employeeName;
    this.employeeDetails.emplID = selected.employeeId;
    this.employeeDetails.guid = selected.guid;
    this.employeeDetails.mobile = this.getPhoneAndCountryCode(selected.phone);
    this.employeeDetails.code = this.employeeDetails.mobile[0];
    this.employeeDetails.phoneNum = this.employeeDetails.mobile[1];
    this.showList = false;
  }

  getPhoneAndCountryCode(mobile): string[] {
    let phoneCode = "";
    let phoneNumber = "";
    if (mobile && !mobile.startsWith("+")) {
      phoneCode = "+91";
      phoneNumber = mobile;
    } else {
      if (mobile) {
        const phoneWithCode = mobile.split('-');
        phoneCode = phoneWithCode[0];
        phoneNumber = phoneWithCode[1];
      }
    }
    return [phoneCode, phoneNumber];
  }

  setInitialValue() {
    this.enableBtn = false;
    this.employeeDetails.emailID = '';
    this.employeeDetails.name = '';
    this.employeeDetails.emplID = '';
    this.employeeDetails.mobile = [];
    this.employeeDetails.code = '';
    this.employeeDetails.phoneNum = '';
    this.employeeDetails.guid = '';
    this.recipientName = 'No recipient Selected';
  }

  submitRecipient() {
    this.openRecipientModal = false;
    this.commonService.saveRecipient(this.requester.emplGuid, this.employeeDetails.guid).subscribe(res => {
    if (res){
       this.recipientName = res.name;
       this.srcPath = 'assets/ic-edit.svg';
    }
      else {
        this.srcPath = 'assets/addRecipient.svg';
    }
    }, (error) => this.setInitialValue()
    );
  }

  validateInput(event) {
    return ((event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 65 && event.charCode <= 90) || ((event.charCode >= 48 && event.charCode <= 57)) || (event.charCode == 32));
  }
  deleteRecipient() {
    this.openRecipientModal = false;
    this.showWarningDialog = true;
  }
  makeButtonSubmitEnable(){
    this.showWarningDialog = false;
    this.setInitialValue();
    this.submitRecipient();
  }
}
